import { graphConfigGroup } from './authConfig';
export async function callMsGraphGroup(accessToken: any) {
  const headers = new Headers();
  const bearer = `Bearer ${accessToken}`;

  headers.append('Authorization', bearer);

  const options = {
    method: 'GET',
    headers: headers,
  };

  return await fetch(graphConfigGroup.graphMeEndpoint, options)
    .then(async (response: any) => await response.json())
    .then(async (respone: any) => {
      const groups = await respone.value.map((g: any) => g.id);
      return groups;
    })
    .catch((error) => console.log(error));
}
